export function money(value, options = {}) {
  const { dash = '—', signed = false } = options;
  if (value == null || Number.isNaN(Number(value))) return dash;
  const number = Number(value);
  if (Math.round(number) === 0 && !signed) return dash;
  const body = Math.abs(Math.round(number)).toLocaleString('en-US');
  if (Math.round(number) < 0) return `($${body})`;
  return signed && number > 0 ? `$+${body}` : `$${body}`;
}

export function numberValue(value) {
  if (value == null || Number.isNaN(Number(value))) return '—';
  return Math.round(Number(value)).toLocaleString('en-US');
}

export function dateLabel(value, options = { month: '2-digit', day: '2-digit', year: 'numeric' }) {
  if (!value) return '—';
  return new Date(`${String(value).slice(0, 10)}T12:00:00`).toLocaleDateString(
    'en-US',
    options,
  );
}

export function dateTimeLabel(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return `${date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  })} ${date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })}`;
}

export function monthLabel(value) {
  const match = String(value || '').match(/^(\d{4})-(\d{1,2})$/);
  return match ? `${String(match[2]).padStart(2, '0')}/${match[1]}` : '—';
}

export function dayLabel(value) {
  if (!value) return '—';
  const date = new Date(`${String(value).slice(0, 10)}T12:00:00`);
  if (Number.isNaN(date.getTime())) return '—';
  return `${date.toLocaleDateString('en-US', { weekday: 'short' })} ${dateLabel(value)}`;
}

export function isWeekendOrHoliday(dateKey, holidays = []) {
  if (!dateKey) return false;
  const date = new Date(`${String(dateKey).slice(0, 10)}T12:00:00`);
  return [0, 6].includes(date.getDay())
    || holidays.some((holiday) => String(holiday?.date || holiday).slice(0, 10) === String(dateKey).slice(0, 10));
}

export function percent(value) {
  if (value == null) return 'n/a';
  const rounded = Number((Number(value) * 100).toFixed(1));
  const body = `${Math.abs(rounded).toFixed(1)}%`;
  return rounded < 0 ? `(${body})` : body;
}

export function longDateLabel(value) {
  if (!value) return '—';
  const date = new Date(`${String(value).slice(0, 10)}T12:00:00`);
  if (Number.isNaN(date.getTime())) return '—';
  const day = date.getDate();
  const suffix = day % 100 >= 11 && day % 100 <= 13
    ? 'th'
    : { 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th';
  const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
  const month = date.toLocaleDateString('en-US', { month: 'long' });
  return `${weekday}, ${month} ${day}${suffix}, ${date.getFullYear()}`;
}
